"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActionCodesForCategory = void 0;
const types_1 = require("../types");
const { TEAM, MOB_USER, WEB_USER, LIST, ITEM, WORKFLOW, ACTIVITY_REPORT, CLIENT, DASHBOARD, DOCUMENT, TERRITORY, CLIENT_SETTINGS, CALENDAR_EVENT, QUERY, ACTIVITY, ORDER, ROUTE, STOCK, } = types_1.OBJECT_CATEGORY;
const { FETCH, CREATE, DELETE, EDIT, ADVANCED_ACTION, ARCHIVE, RESTORE } = types_1.ACTION_TYPE;
const ACTIONS_BY_CATEGORY = {
    [QUERY]: [
        //write query is as edit
        `${EDIT}_${QUERY}`,
    ],
    [TEAM]: [
        `${FETCH}_${TEAM}`,
        `${CREATE}_${TEAM}`,
        `${DELETE}_${TEAM}`,
        `${EDIT}_${TEAM}`,
        `${ADVANCED_ACTION}_${TEAM}`,
    ],
    [MOB_USER]: [
        `${FETCH}_${MOB_USER}`,
        `${CREATE}_${MOB_USER}`,
        `${DELETE}_${MOB_USER}`,
        `${EDIT}_${MOB_USER}`,
        `${ADVANCED_ACTION}_${MOB_USER}`,
    ],
    [WEB_USER]: [
        `${FETCH}_${WEB_USER}`,
        `${CREATE}_${WEB_USER}`,
        `${DELETE}_${WEB_USER}`,
        `${EDIT}_${WEB_USER}`,
        `${ADVANCED_ACTION}_${WEB_USER}`,
    ],
    [LIST]: [
        `${FETCH}_${LIST}`,
        `${CREATE}_${LIST}`,
        `${DELETE}_${LIST}`,
        `${EDIT}_${LIST}`,
        `${ARCHIVE}_${LIST}`,
        `${RESTORE}_${LIST}`,
        `${ADVANCED_ACTION}_${LIST}`,
    ],
    [ITEM]: [
        `${FETCH}_${ITEM}`,
        `${CREATE}_${ITEM}`,
        `${DELETE}_${ITEM}`,
        `${EDIT}_${ITEM}`,
        `${ARCHIVE}_${ITEM}`,
        `${RESTORE}_${ITEM}`,
        `${ADVANCED_ACTION}_${ITEM}`,
    ],
    [WORKFLOW]: [
        `${FETCH}_${WORKFLOW}`,
        `${CREATE}_${WORKFLOW}`,
        `${DELETE}_${WORKFLOW}`,
        `${EDIT}_${WORKFLOW}`,
        `${ADVANCED_ACTION}_${WORKFLOW}`,
    ],
    [ACTIVITY]: [
        `${FETCH}_${ACTIVITY}`,
        `${CREATE}_${ACTIVITY}`,
        `${DELETE}_${ACTIVITY}`,
        `${EDIT}_${ACTIVITY}`,
        `${ADVANCED_ACTION}_${ACTIVITY}`,
    ],
    // IMPORTANT: ACTIVITY_REPORT is also used for other kinds of reports (Workflow reports, ...)
    [ACTIVITY_REPORT]: [
        `${FETCH}_${ACTIVITY_REPORT}`,
        `${CREATE}_${ACTIVITY_REPORT}`,
        `${DELETE}_${ACTIVITY_REPORT}`,
        `${EDIT}_${ACTIVITY_REPORT}`,
    ],
    [DASHBOARD]: [
        `${FETCH}_${DASHBOARD}`,
        `${CREATE}_${DASHBOARD}`,
        `${DELETE}_${DASHBOARD}`,
        `${EDIT}_${DASHBOARD}`,
        `${ADVANCED_ACTION}_${DASHBOARD}`,
        "VIEW_DEFAULT_DASHBOARDS",
        "EXPORT_CLIENT_DATA",
    ],
    [DOCUMENT]: [
        `${FETCH}_${DOCUMENT}`,
        `${CREATE}_${DOCUMENT}`,
        `${DELETE}_${DOCUMENT}`,
    ],
    [CLIENT]: [
        `${FETCH}_${CLIENT}`,
        `${CREATE}_${CLIENT}`,
        `${DELETE}_${CLIENT}`,
        `${EDIT}_${CLIENT}`,
        `${ADVANCED_ACTION}_${CLIENT}`,
    ],
    [TERRITORY]: [
        `${FETCH}_${TERRITORY}`,
        `${CREATE}_${TERRITORY}`,
        `${DELETE}_${TERRITORY}`,
        `${EDIT}_${TERRITORY}`,
        `${ADVANCED_ACTION}_${TERRITORY}`,
    ],
    [CLIENT_SETTINGS]: [
        `${FETCH}_${CLIENT_SETTINGS}`,
        `${EDIT}_${CLIENT_SETTINGS}`,
    ],
    [CALENDAR_EVENT]: [
        `${FETCH}_${CALENDAR_EVENT}`,
        `${CREATE}_${CALENDAR_EVENT}`,
        `${DELETE}_${CALENDAR_EVENT}`,
        `${EDIT}_${CALENDAR_EVENT}`,
    ],
    [ORDER]: [
        `${FETCH}_${ORDER}`,
        `${CREATE}_${ORDER}`,
        `${DELETE}_${ORDER}`,
        `${EDIT}_${ORDER}`,
    ],
    [ROUTE]: [
        `${FETCH}_${ROUTE}`,
        `${CREATE}_${ROUTE}`,
        `${DELETE}_${ROUTE}`,
        `${EDIT}_${ROUTE}`,
    ],
    [STOCK]: [
        `${FETCH}_${STOCK}`,
        `${CREATE}_${STOCK}`,
        `${DELETE}_${STOCK}`,
        `${EDIT}_${STOCK}`,
    ],
};
const getActionCodesForCategory = (category) => {
    if (!category) {
        return [];
    }
    return ACTIONS_BY_CATEGORY[category] || [];
};
exports.getActionCodesForCategory = getActionCodesForCategory;
